<template>
  <div class="modal" :class="{ 'is-active': showModal }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Últimas cuentas {{ table.type }} {{ table.name }}
        </p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div>
          <table class="table is-fullwidth is-narrow">
            <thead>
              <tr>
                <th>Fecha y hora</th>
                <th>Total</th>
                <th>Detalle</th>
              </tr>
            </thead>
            <tbody v-if="bills.length > 0">
              <tr v-for="b in bills" :key="b.uuid">
                <td>
                  <button class="is-outlined" @click="showPrint(b.uuid)">
                    <span class="material-symbols-outlined">print</span>
                  </button>
                  {{ formatDate(b.created_at) }}
                </td>
                <td class="has-text-right" style="white-space: nowrap">
                  {{ currency(b.total) }}
                </td>
                <td>
                  <span
                    v-for="i in b.items"
                    :key="i.timestamp"
                    class="tag"
                    :class="{ 'is-danger is-removed': i.is_deleted }"
                  >
                    {{ currency(i.due) }}
                  </span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="has-text-centered">
                  Aún no se registra atención.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" @click="close">
          <span class="material-symbols-outlined">close</span>&nbsp;Cerrar
        </button>
      </footer>
    </div>
    <receipt-print
      v-if="showPrintToggle"
      :shop="shop"
      :bill_id="bill_id"
      :showModal="showPrintToggle"
      @close-modal="closePrint"
    />
  </div>
</template>

<script>
import { format } from "date-fns";
import axios from "axios";
// import ReceiptPrint from "@/components/ReceiptPrint";
import ReceiptPrint from "./ReceiptPrint";

export default {
  components: { ReceiptPrint },
  name: "TableBucketBillHistory",
  data() {
    return {
      bills: [],
      shop: {},
      bill_id: null,
      showPrintToggle: false,
    };
  },
  componets: {
    ReceiptPrint,
  },
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
    table: {
      type: Object,
    },
  },
  methods: {
    close() {
      this.$emit("closeModal");
    },
    async getBillHistory() {
      await axios
        .get(`/api/v1/shop${this.table.get_absolute_url}bills/latest`)
        .then((response) => {
          this.bills = response.data;
        })
        .catch((error) => {
          // TODO: Handle Token Expiration
          console.log(error);
        });
    },
    formatDate(date) {
      return format(new Date(date), "p");
    },
    currency(val) {
      let cur = Intl.NumberFormat("es-CO");
      return `$ ${cur.format(val)}`;
    },
    showPrint(b) {
      console.log(b);
      if (b) {
        this.bill_id = b;
        this.showPrintToggle = true;
      }
    },
    closePrint() {
      this.showPrintToggle = false;
      this.bill_id = null;
    },
  },
  mounted() {
    this.shop = this.$store.getters.getShop.slug;
    this.getBillHistory();
  },
};
</script>

<style scoped>
.modal-background {
  background-color: rgba(10, 10, 10, 0.4);
}
.is-removed {
  text-decoration: line-through;
}
</style>
